import { combineReducers } from "redux";
import { reducer as rates } from "./ListRates";

export default combineReducers({
  rates
});
